<popup-c class="bs-enabled no-content-padding" [head]="popupHead" [subTitle]="popupSubtitle"
         size="large" width="1400px"
         (closeCb)="data.closeCb()">
    <div class="flex-column f-1-0 gap-2" style="overflow: auto; line-height: 1.4;">

		<div class="flex-column f-1-0 gap-2 overflow-auto p-2">
			<!--SECTION: Plan Manager (create + allocate)-->
			<div class="border rounded p-3 flex-row gap-2 position-relative"
				 *ngIf="data.mode === 'create' || data.mode === 'allocate'"
				 [ngClass]="{'border-secondary shadow' : activeSection === sections.planManager}">

				<a class="blue-link animated fadeIn" style="position: absolute; top: 5px; right: 10px; z-index: 50;"
				   *ngIf="completedSections.has(sections.planManager) && activeSection !== sections.planManager"
				   (click)="editSection(sections.planManager)">Edit</a>

				<span class="text-uppercase fw-500 f-1-0" style="font-size: 0.95rem;">Plan Manager</span>

				<!--Summary-->
				<ul class="text-muted mb-0 animated fadeIn" style="padding-left: 20px; min-width: min(1050px,72vw); flex: 0 1;"
					*ngIf="completedSections.has(sections.planManager) && activeSection !== sections.planManager">
					<li *ngIf="data.curSharedUser.planManagedBy === dic.CONSTANTS.planManagedBy.you">
						A Plan Managed by You{{data.curSharedUser.domain ? '. Primary domain: ' + data.curSharedUser.domain : ''}}
					</li>
					<li *ngIf="data.curSharedUser.planManagedBy === dic.CONSTANTS.planManagedBy.admin">
						A Plan Managed Independently. Email: {{data.curSharedUser.email}}
					</li>
					<li *ngIf="data.curSharedUser.planManagedBy === allocatePlanManagedByOptions.template">
						A Configuration Template: {{data.curSharedUser.templateName || '(unnamed)'}}
					</li>
				</ul>

				<div class="flex-column gap-3 animated fadeIn" style="min-width: min(1050px,72vw); flex: 0 1;"
					 *ngIf="activeSection === sections.planManager">

					<b class="text-primary" style="font-size: 16px;">What are you looking to create?</b>

					<!--Manager type cards-->
					<div class="flex-row gap-3 align-items-start">
						<!--You card-->
						<div class="selectable-card flex-column border border-2 rounded p-2 f-1-0 gap-0 position-relative"
							 style="min-height: 160px;"
							 [class.active]="data.curSharedUser.planManagedBy === dic.CONSTANTS.planManagedBy.you"
							 (click)="data.curSharedUser.planManagedBy = dic.CONSTANTS.planManagedBy.you">
							<i class="far fa-check-circle text-primary"
							   style="position: absolute; top: 8px; left: 8px; font-size: 1rem;"
							   *ngIf="data.curSharedUser.planManagedBy === dic.CONSTANTS.planManagedBy.you"></i>
							<div class="flex-column align-items-center gap-2">
								<div class="flex-row align-items-center gap-2">
									<i class="far fa-user-tie text-primary" style="font-size: 1.4rem;"></i>
									<b style="font-size: 16px;">A Plan Managed by You</b>
								</div>
								<span class="text-muted text-center">Recommended for MSPs and partners. This allows you to provision a customer plan and immediately move into the setup, configuration, and ongoing management of that plan.</span>
							</div>
							<div class="p-2" style="overflow: hidden; transition: max-height 0.3s ease;"
								 [style.padding]="data.curSharedUser.planManagedBy === dic.CONSTANTS.planManagedBy.you ? '' : '0 !important'"
								 [style.max-height]="data.curSharedUser.planManagedBy === dic.CONSTANTS.planManagedBy.you ? '56px' : '0'">
								<div class="d-flex centralize gap-2 pt-3">
									<span style="flex-basis: 105px; flex-shrink: 0;">Primary domain:</span>
									<input type="text" style="width: 150px;"
										   [appAutoFocus]="true"
										   [(ngModel)]="data.curSharedUser.domain">
									<i class="far fa-question-circle"
									   tooltip="This will be the main domain to which most of the plan users belong. It will be possible to add more domains to the plan after you create it"></i>
								</div>
							</div>
						</div>

						<!--Independently managed card-->
						<div class="selectable-card flex-column border border-2 rounded p-2 f-1-0 gap-0 position-relative"
							 style="min-height: 160px;"
							 [class.active]="data.curSharedUser.planManagedBy === dic.CONSTANTS.planManagedBy.admin"
							 (click)="data.curSharedUser.planManagedBy = dic.CONSTANTS.planManagedBy.admin">
							<i class="far fa-check-circle text-primary"
							   style="position: absolute; top: 8px; left: 8px; font-size: 1rem;"
							   *ngIf="data.curSharedUser.planManagedBy === dic.CONSTANTS.planManagedBy.admin"></i>
							<div class="flex-column align-items-center gap-2">
								<div class="flex-row align-items-center gap-2">
									<i class="far fa-user-circle-plus text-primary" style="font-size: 1.4rem;"></i>
									<b style="font-size: 16px;">A Plan Managed Independently</b>
								</div>
								<span class="text-muted text-center">Recommended when the customer's own administrative team will be responsible for setup and ongoing management. This creates the plan without placing it under the partner's direct management.</span>
							</div>
							<div style="overflow: hidden; transition: max-height 0.3s ease;"
								 [style.padding]="data.curSharedUser.planManagedBy === dic.CONSTANTS.planManagedBy.admin ? '' : '0 !important'"
								 [style.max-height]="data.curSharedUser.planManagedBy === dic.CONSTANTS.planManagedBy.admin ? '96px' : '0'">
								<div class="flex-column gap-2 pt-3">
									<div class="d-flex centralize gap-2">
										<span style="flex-basis: 56px;">Email:</span>
										<input type="text" style="width: 200px;"
											   [(ngModel)]="data.curSharedUser.email">
									</div>
									<div class="d-flex centralize gap-2">
										<span style="flex-basis: 56px;">Name:</span>
										<input type="text" placeholder="(Optional)"
											   style="width: 200px;"
											   [(ngModel)]="data.curSharedUser.name">
									</div>
								</div>
							</div>
						</div>

						<!--Template card-->
						<div class="selectable-card flex-column align-items-center border border-2 rounded p-2 f-1-0 gap-2 position-relative"
							 style="min-height: 160px;"
							 [class.active]="data.curSharedUser.planManagedBy === allocatePlanManagedByOptions.template"
							 (click)="data.curSharedUser.planManagedBy = allocatePlanManagedByOptions.template">
							<i class="far fa-check-circle text-primary"
							   style="position: absolute; top: 8px; left: 8px; font-size: 1rem;"
							   *ngIf="data.curSharedUser.planManagedBy === allocatePlanManagedByOptions.template"></i>
							<div class="flex-row align-items-center gap-2">
								<i class="far fa-clipboard-list text-primary" style="font-size: 1.4rem;"></i>
								<b style="font-size: 16px;">A Configuration Template</b>
							</div>
							<span class="text-muted text-center">Configuration Templates allow you to build a standardized set of policies, rules, and settings that can be applied to existing plans or used when provisioning future plans.</span>
						</div>
					</div>

					<!--Template details (shown only when Template is selected)-->
					<div class="flex-column gap-3 animated fadeIn mt-3"
						 *ngIf="data.curSharedUser.planManagedBy === allocatePlanManagedByOptions.template">
						<div class="flex-column gap-4">
							<div class="flex-row align-items-center gap-2">
								<span style="flex-basis: 125px; flex-shrink: 0;">Template name:</span>
								<input type="text"
									   style="width: 227px;"
									   maxlength="100"
									   [(ngModel)]="data.curSharedUser.templateName" />
							</div>
							<div class="flex-row gap-2">
								<span style="flex-basis: 125px; flex-shrink: 0;">Template type:</span>
								<div class="flex-row gap-3 overflow-auto">
									<div class="selectable-card flex-row f-1-0 gap-2 p-2 bg-white border border-2 rounded-3 position-relative"
										 style="min-width: 200px; word-break: break-word;"
										 *ngFor="let template of data.sharedPlanInfo.defaultTemplates"
										 [class.active]="data.curSharedUser.selectedDefaultTemplate?.name === template.name"
										 (click)="data.curSharedUser.selectedDefaultTemplate = template; data.selectPlanTemplateType = selectPlanTemplateTypes.duplicate;">
										<i class="far fa-check-circle text-primary"
										   style="position: absolute; top: 8px; right: 8px; font-size: 1rem;"
										   *ngIf="data.curSharedUser.selectedDefaultTemplate?.name === template.name"></i>
										<i class="far fa-clipboard-list align-self-start p-2 bg-light text-muted rounded-3" style="font-size: 1.1rem"></i>
										<div class="flex-column f-1-0 gap-2">
										<span class="fw-bold" style="white-space: normal;"
											  [ngClass]="{'text-primary': data.curSharedUser.selectedDefaultTemplate?.name === template.name}">
											{{template.name}}
										</span>
											<span class="text-muted">{{template.desc || ''}}</span>
										</div>
									</div>
									<!--Empty template card-->
									<div class="selectable-card flex-row f-1-0 gap-2 p-2 bg-white border border-2 rounded-3 position-relative"
										 style="min-width: 200px; word-break: break-word;"
										 [class.active]="data.selectPlanTemplateType === selectPlanTemplateTypes.new"
										 (click)="data.curSharedUser.selectedDefaultTemplate = null; data.selectPlanTemplateType = selectPlanTemplateTypes.new;">
										<i class="far fa-check-circle text-primary"
										   style="position: absolute; top: 8px; right: 8px; font-size: 1rem;"
										   *ngIf="data.selectPlanTemplateType === selectPlanTemplateTypes.new"></i>
										<i class="far fa-file p-2 align-self-start bg-light text-muted rounded-3" style="font-size: 1.1rem"></i>
										<div class="flex-column f-1-0 gap-2">
										<span class="fw-bold" style="white-space: normal;"
											  [ngClass]="{'text-primary': data.selectPlanTemplateType === selectPlanTemplateTypes.new}">
											Empty template
										</span>
											<span class="text-muted">Start from scratch with your own configurations</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<btn-c class="align-self-end popup-action-btn p-2" *ngIf="!allSectionsCompleted" (action)="nextSection(sections.planManager)">Next</btn-c>
				</div>

			</div>

			<!--SECTION: Plan Details-->
			<div class="border rounded p-3 flex-row gap-2 position-relative animated fadeIn"
				 *ngIf="data.curSharedUser.planManagedBy !== allocatePlanManagedByOptions.template"
				 [ngClass]="{'border-secondary shadow' : activeSection === sections.planDetails}">

				<a class="blue-link animated fadeIn" style="position: absolute; top: 5px; right: 10px; z-index: 50;"
				   *ngIf="completedSections.has(sections.planDetails) && activeSection !== sections.planDetails"
				   (click)="editSection(sections.planDetails)"
				   tooltip='Click "Edit" to modify configuration'
				   trigger="manual"
				   placement="left"
				   theme="light"
				   tooltipClass="triggered-info-tooltip"
				   #firstEditTooltip="tooltip">Edit</a>

				<span class="text-uppercase fw-500 f-1-0" style="font-size: 0.95rem;">Plan Details</span>

				<!--Summary-->
				<ul class="text-muted mb-0 animated fadeIn" style="padding-left: 20px; min-width: min(1050px,72vw); flex: 0 1;"
					*ngIf="completedSections.has(sections.planDetails) && activeSection !== sections.planDetails">
					<li>{{dic.CONSTANTS.planSubTypeMap[data.curSharedUser.planSubType]}} - {{summaryExpirationDisplay}}</li>
					<li *ngIf="data.curSharedUser.companyName">Company: {{data.curSharedUser.companyName}}</li>
					<li *ngIf="data.curSharedUser.customerId">Partner ID: {{data.curSharedUser.customerId}}</li>
					<li *ngIf="data.copyPolicyData?.enabled && data.copyPolicyData?.selectedPolicyTemplate">
						Copy policy "{{data.copyPolicyData.selectedPolicyTemplate.name}}" from {{data.copyPolicyData.selectedFromAdmin?.email}}
					</li>
				</ul>

				<div class="list-group list-group-flush settings-list-container animated fadeIn"
					 style="min-width: min(1050px,72vw); flex: 0 1;"
					 *ngIf="activeSection === sections.planDetails">

					<!--Plan type section-->
					<div class="list-group-item settings-list-item gap-2 py-3">
						<div class="title-section-container flex-column gap-1" style="max-width: 300px;">
							<b>Plan type</b>
							<span class="text-muted lh-base" style="font-size: 0.9em;">
								Select the billing cycle and expiration for this plan.
							</span>
						</div>
						<div class="content-container flex-column gap-4">
							<!--Plan type cards-->
							<div class="flex-row gap-3">
								<div class="selectable-card border border-2 rounded p-2 text-center position-relative f-1-0"
									 [class.active]="data.curSharedUser.planSubType === dic.CONSTANTS.planSubType.annual"
									 (click)="changePlanSubType(dic.CONSTANTS.planSubType.annual)">
									<i class="far fa-check-circle text-primary"
									   style="position: absolute; top: 0; left: 2px; font-size: 1rem;"
									   *ngIf="data.curSharedUser.planSubType === dic.CONSTANTS.planSubType.annual"></i>
									<span class="fw-bold">Annual</span>
								</div>
								<div class="selectable-card border border-2 rounded p-2 text-center position-relative f-1-0"
									 [class.active]="data.curSharedUser.planSubType === dic.CONSTANTS.planSubType.msp"
									 (click)="changePlanSubType(dic.CONSTANTS.planSubType.msp)">
									<i class="far fa-check-circle text-primary"
									   style="position: absolute; top: 0; left: 2px; font-size: 1rem;"
									   *ngIf="data.curSharedUser.planSubType === dic.CONSTANTS.planSubType.msp"></i>
									<span class="fw-bold">Monthly</span>
								</div>
								<div class="selectable-card border border-2 rounded p-2 text-center position-relative f-1-0"
									 [class.active]="data.curSharedUser.planSubType === dic.CONSTANTS.planSubType.poc"
									 (click)="changePlanSubType(dic.CONSTANTS.planSubType.poc)">
									<i class="far fa-check-circle text-primary"
									   style="position: absolute; top: 0; left: 2px; font-size: 1rem;"
									   *ngIf="data.curSharedUser.planSubType === dic.CONSTANTS.planSubType.poc"></i>
									<span class="fw-bold">Proof of Concept (PoC)</span>
								</div>
							</div>

							<!--Expiration date-->
							<div class="flex-row align-items-center gap-2">
								<span style="flex-basis: 110px;">Expiration date:</span>
								<label style="margin-bottom: 0; display: contents;"
									   *ngIf="data.curSharedUser.planSubType === dic.CONSTANTS.planSubType.annual">
									<div class="plan-expiration-extend-menu" style="position: relative; width: 230px; display: inline-block; cursor: unset;">
										<input type="text" style="margin: 0; width: 100%;"
											   [value]="data.curSharedUser.newExpirationDate ? (data.curSharedUser.newExpirationDate | date: 'MM/dd/yyyy') : (data.curSharedUser.adminExpirationDate | date: 'MM/dd/yyyy')"
											   [readOnly]="true"
											   [ngClass]="{'text-success fw-bold': data.curSharedUser.extendExpirationMethod}"
											   readonly />
										<a class="blue-link" style="position: absolute; top: 50%; transform: translateY(-50%); right: 10px; font-size: 12px;"
										   (click)="data.curSharedUser.isExtendExpirationMenuOpen = !data.curSharedUser.isExtendExpirationMenuOpen; $event.preventDefault();"
										   (clickOutside)="data.curSharedUser.isExtendExpirationMenuOpen = false;"
										   [exclude]="'#wizardExtendExpirationMenu'">
											Extend
										</a>
										<div class="drop-menu"
											 style="padding: 0; min-width: 0; min-height: 0; max-width: none; max-height: none; width: 165px; height: auto; box-shadow: 1px 0 3px #cccccc; border-radius: 5px; border: solid 1px lightgrey; left: auto; top: 0; bottom: auto; right: -3px;"
											 [ngClass]="{'active': data.curSharedUser.isExtendExpirationMenuOpen}"
											 id="wizardExtendExpirationMenu">
											<ul>
												<li *ngFor="let period of expandMethods | keyvalue: gs.returnZero"
													[hidden]="data.mode === 'modify' && (period.key === 'twoYears' || period.key === 'threeYears')"
													(click)="updateExpirationTime(period.value.value); prepareInvoiceNotifyMessage();">
													<div class="flxRow hSpace05" style="align-items: center;"
														 [ngStyle]="{'font-weight': data.curSharedUser.extendExpirationMethod === period.value.value ? 'bold' : 'normal'}">
														<i class="far fa-plus"></i>
														<span>Add {{period.value.display}}</span>
													</div>
												</li>
											</ul>
										</div>
										<a class="closeRed animated fadeIn"
										   style="position: absolute; top: 50%; transform: translateY(-50%); right: -25px; padding: 5px; opacity: 0.5;"
										   tooltip="Cancel extending"
										   *ngIf="data.curSharedUser.extendExpirationMethod && data.mode === 'modify'"
										   (click)="cancelExtendExpirationDate()">
											<i class="far fa-times"></i>
										</a>
									</div>
								</label>
								<input type="text" style="margin: 0; width: 230px;" readonly
									   *ngIf="data.curSharedUser.planSubType === dic.CONSTANTS.planSubType.msp"
									   [value]="data.curSharedUser.adminExpirationDate | date: 'MM/dd/yyyy'" />
								<date-picker-c
									*ngIf="data.curSharedUser.planSubType !== dic.CONSTANTS.planSubType.annual && data.curSharedUser.planSubType !== dic.CONSTANTS.planSubType.msp"
									[(dateModel)]="data.curSharedUser.adminExpirationDate"
									[dateMinLimit]="data.curSharedUser.showOldExpirationDate ? data.curSharedUser.adminExpirationDateString : data.adminExpirationDateMinString"
									[dateMaxLimit]="data.adminExpirationDateMaxString"
									[allowFuture]="true" style="width: 230px; display: inline-block;">
								</date-picker-c>
								<span class="text-muted animated fadeIn" *ngIf="data.curSharedUser.planSubType === dic.CONSTANTS.planSubType.msp">
									Automatically renewed monthly
								</span>
							</div>
						</div>
					</div>

					<!--Other details section-->
					<div class="list-group-item settings-list-item gap-2 py-3">
						<div class="title-section-container flex-column gap-1" style="max-width: 300px;">
							<b>Other details</b>
							<span class="text-muted lh-base" style="font-size: 0.9em;">
								Optional information to identify and organize this plan.
							</span>
						</div>
						<div class="content-container flex-column gap-3">
							<div class="flex-row align-items-center gap-2">
								<span style="flex-basis: 110px;">Company name:</span>
								<input type="text"
									   style="width: 230px; border-radius: 4px; box-sizing: border-box; border: 1px solid #ccc; padding: 2px 8px;"
									   maxlength="100"
									   placeholder="(Recommended)"
									   [(ngModel)]="data.curSharedUser.companyName" />
							</div>
							<div class="flex-row align-items-center gap-2">
								<span style="flex-basis: 110px;">Partner ID:</span>
								<input type="text"
									   style="width: 230px; border-radius: 4px; box-sizing: border-box; border: 1px solid #ccc; padding: 2px 8px;"
									   maxlength="100"
									   placeholder="(Optional)"
									   [(ngModel)]="data.curSharedUser.customerId"
									   pattern="/^[a-zA-Z]*$/"/>
							</div>
							<div class="flex-row gap-2">
								<span style="flex-basis: 110px;"></span>
								<div class="flex-row gap-2 text-muted" style="max-width: 400px;">
									<i class="far fa-info-circle me-1"></i>
									<span>Assigning a Partner ID grants this admin the ability to create and allocate plans to other users.</span>
								</div>
							</div>
						</div>
					</div>

					<!--Copy Policy section (conditional)-->
					<div class="list-group-item settings-list-item gap-2 py-3"
						 *ngIf="data.planPolicies?.length">
						<div class="title-section-container flex-column gap-1" style="max-width: 300px;">
							<b>Copy policy</b>
							<span class="text-muted lh-base" style="font-size: 0.9em;">
								Optionally copy a policy template from an existing plan to this new plan.
							</span>
						</div>
						<div class="content-container flex-column gap-3">
							<div class="flex-row align-items-center gap-2">
								<div style="flex-basis: 110px;">
									<checkbox id="wizardCopyPolicy" style="justify-content: start !important;"
											  [(model)]="data.copyPolicyData.enabled">
										Copy policy:
									</checkbox>
								</div>
								<div class="flex-row gap-2 f-1-0 align-items-center">
									<app-dropdown-c class="show-above f-1-0"
													[items]="data.planPolicies" itemDisplayKey="name"
													[text]="data.copyPolicyData.selectedPolicyTemplate?.name || 'Select'"
													[error]="data.copyPolicyData.error"
													[isDisabled]="!data.copyPolicyData.enabled"
													(onItemClicked)="data.copyPolicyData.selectedPolicyTemplate = $event.item; data.copyPolicyData.error = null;"
													[enableSearch]="true">
									</app-dropdown-c>
									<span>from:</span>
									<app-dropdown-c class="show-above f-1-0"
													[text]="data.copyPolicyData.selectedFromAdmin?.email"
													[enableSearch]="true"
													itemDisplayKey="email"
													[isDisabled]="!data.copyPolicyData.enabled"
													[items]="gs.planAdmins"
													(onItemClicked)="data.copyPolicyData.selectedFromAdmin = $event.item">
									</app-dropdown-c>
								</div>
							</div>
						</div>
					</div>

					<div class="flex-row align-self-end gap-2" *ngIf="!allSectionsCompleted">
						<btn-c class="popup-action-btn p-2" variant="outlined" (action)="prevSection(sections.planDetails)">Back</btn-c>
						<btn-c class="popup-action-btn p-2" (action)="nextSection(sections.planDetails)">Next</btn-c>
					</div>
				</div>
			</div>

			<!--SECTION: Plan Features-->
			<div class="border rounded p-3 flex-row gap-2 position-relative animated fadeIn"
				 *ngIf="data.curSharedUser.planManagedBy !== allocatePlanManagedByOptions.template"
				 [ngClass]="{'border-secondary shadow' : activeSection === sections.planFeatures}">

				<a class="blue-link animated fadeIn" style="position: absolute; top: 5px; right: 10px; z-index: 50;"
				   *ngIf="completedSections.has(sections.planFeatures) && activeSection !== sections.planFeatures"
				   (click)="editSection(sections.planFeatures)">Edit</a>

				<span class="text-uppercase fw-500 f-1-0" style="font-size: 0.95rem;">Plan Features</span>

				<!--Summary-->
				<ul class="text-muted mb-0 animated fadeIn" style="padding-left: 20px; min-width: min(1050px,72vw); flex: 0 1;"
					*ngIf="completedSections.has(sections.planFeatures) && activeSection !== sections.planFeatures">
					<li>Outbound Shield: {{data.curSharedUser.allowedUsers}} license(s)</li>
					<li>Inbound Shield: {{data.curSharedUser.allowedLicenses}} license(s)</li>
					<li *ngIf="data.curSharedUser.archive">Archive enabled</li>
					<li *ngIf="data.curSharedUser.threat_simulation">Threat Simulation enabled</li>
					<li *ngIf="data.curSharedUser.allow_support_wa">Support Tickets enabled</li>
					<li *ngIf="data.curSharedUser.hide_partner_access">Limited Access enabled</li>
				</ul>

				<div class="list-group list-group-flush settings-list-container animated fadeIn"
					 style="min-width: min(1050px,72vw); flex: 0 1;"
					 *ngIf="activeSection === sections.planFeatures">

					<!--Resources section-->
					<div class="list-group-item settings-list-item gap-2 py-3">
						<div class="title-section-container flex-column gap-1" style="max-width: 300px;">
							<b>Resources</b>
							<span class="text-muted lh-base" style="font-size: 0.9em;">
								Allocate outbound and inbound license capacity for this plan.
							</span>
						</div>
						<div class="content-container flex-column gap-3">
							<div class="flex-row gap-3">
								<!--Outbound Shield card-->
								<div class="selectable-card f-1-0 cursor-default border border-2 rounded p-2 flex-column align-items-center justify-content-center text-center gap-2 position-relative active">
									<i class="far fa-check-circle text-muted"
									   style="position: absolute; top: 8px; left: 8px; font-size: 1rem;"></i>
									<div class="flex-column align-items-center gap-2">
										<div class="flex-row align-items-center gap-2">
											<i class="far fa-shield text-primary" style="font-size: 1.5rem;"></i>
											<b style="font-size: 15px;">Outbound Shield</b>
										</div>
										<div class="flex-row mt-1 align-items-center gap-2">
											<span>Licenses:</span>
											<input type="number" min="1" step="1"
												   style="width: 90px;"
												   [(ngModel)]="data.curSharedUser.allowedUsers"
												   (change)="prepareInvoiceNotifyMessage();">
										</div>
										<span [ngClass]="data.curSharedUser.allowedUsers > availableUsers ? 'text-danger' : 'text-muted'" *ngIf="data.currentAdminObj">
											Available: {{availableUsers}}
										</span>
									</div>
								</div>
								<!--Inbound Shield card-->
								<div class="selectable-card f-1-0 cursor-default border border-2 rounded p-2 flex-column align-items-center justify-content-center text-center gap-2 position-relative"
									 [class.active]="data.curSharedUser.allowedLicenses > 0">
									<i class="far fa-check-circle text-primary"
									   style="position: absolute; top: 8px; left: 8px; font-size: 1rem;"
									   *ngIf="data.curSharedUser.allowedLicenses > 0"></i>
									<div class="flex-column align-items-center gap-2">
										<div class="flex-row align-items-center gap-2">
											<i class="far fa-user-shield text-primary" style="font-size: 1.5rem;"></i>
											<b style="font-size: 15px;">Inbound Shield</b>
										</div>
										<div class="flex-row mt-1 align-items-center gap-2">
											<span>Licenses:</span>
											<input type="number" min="0" step="1"
												   style="width: 90px;"
												   [(ngModel)]="data.curSharedUser.allowedLicenses"
												   (change)="prepareInvoiceNotifyMessage();">
										</div>
										<span [ngClass]="data.curSharedUser.allowedLicenses > availableLicenses ? 'text-danger' : 'text-muted'" *ngIf="data.currentAdminObj">
											Available: {{availableLicenses}}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!--Features section-->
					<div class="list-group-item settings-list-item gap-2 py-3">
						<div class="title-section-container flex-column gap-1" style="max-width: 300px;">
							<b>Features</b>
							<span class="text-muted lh-base" style="font-size: 0.9em;">
								Expand the plan with premium product modules.
							</span>
						</div>
						<div class="content-container flex-column gap-3">
							<div class="flex-row gap-3 flex-wrap justify-content-start">
								<div class="selectable-card border border-2 rounded p-2 flex-column align-items-center justify-content-center text-center gap-2 position-relative"
									 style="width: 150px;"
									 *ngIf="data.sharedPlanInfo.archive"
									 [class.active]="data.curSharedUser.archive"
									 (click)="data.curSharedUser.archive = !data.curSharedUser.archive">
									<i class="far fa-check-circle text-primary"
									   style="position: absolute; top: 8px; left: 8px; font-size: 1rem;"
									   *ngIf="data.curSharedUser.archive"></i>
									<div class="flex-column align-items-center text-center gap-2">
										<i class="far fa-archive text-primary" style="font-size: 1.3rem;"></i>
										<b>Archive</b>
									</div>
								</div>
								<div class="selectable-card border border-2 rounded p-2 flex-column align-items-center justify-content-center text-center gap-2 position-relative"
									 style="width: 150px;"
									 *ngIf="data.sharedPlanInfo.threat_simulation"
									 [class.active]="data.curSharedUser.threat_simulation"
									 (click)="data.curSharedUser.threat_simulation = !data.curSharedUser.threat_simulation">
									<i class="far fa-check-circle text-primary"
									   style="position: absolute; top: 8px; left: 8px; font-size: 1rem;"
									   *ngIf="data.curSharedUser.threat_simulation"></i>
									<div class="flex-column align-items-center text-center gap-2">
										<div style="margin-top: 6px; flex-shrink: 0; width: 26px; height: 26px; color: var(--bs-primary); background: var(--bs-primary); mask-size: auto 26px; -webkit-mask-size: auto 26px; mask-repeat: no-repeat; -webkit-mask-repeat: no-repeat; mask-image: url('images/double-hook.svg');"></div>
										<b>Threat Simulation</b>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!--More Options section-->
					<div class="list-group-item settings-list-item gap-2 py-3">
						<div class="title-section-container flex-column gap-1" style="max-width: 300px;">
							<b>More Options</b>
							<span class="text-muted lh-base" style="font-size: 0.9em;">
								Control portal access and features available to plan users.
							</span>
						</div>
						<div class="content-container flex-column gap-3">
							<div class="flex-row gap-3 flex-wrap justify-content-start">
								<div class="selectable-card border border-2 rounded p-3 f-1-0 flex-column align-items-center justify-content-center text-center gap-2 position-relative"
									 style="min-width: 31%"
									 [class.active]="data.curSharedUser.allow_support_wa"
									 (click)="data.curSharedUser.allow_support_wa = !data.curSharedUser.allow_support_wa">
									<i class="far fa-check-circle text-primary"
									   style="position: absolute; top: 8px; left: 8px; font-size: 1rem;"
									   *ngIf="data.curSharedUser.allow_support_wa"></i>
									<div class="flex-column f-1-0 align-items-center gap-2">
										<div class="flex-row align-items-center gap-2">
											<i class="far fa-ticket text-primary" style="font-size: 1.3rem;"></i>
											<b>Support Tickets</b>
										</div>
										<span class="text-muted f-1-0" style="font-size: 0.9em;">Allow users to create and view support tickets from the portal</span>
									</div>
								</div>
								<div class="selectable-card border border-2 rounded p-3 f-1-0 flex-column align-items-center justify-content-center text-center gap-2 position-relative"
									 style="min-width: 31%"
									 [class.active]="data.curSharedUser.hide_partner_access"
									 (click)="data.curSharedUser.hide_partner_access = !data.curSharedUser.hide_partner_access">
									<i class="far fa-check-circle text-primary"
									   style="position: absolute; top: 8px; left: 8px; font-size: 1rem;"
									   *ngIf="data.curSharedUser.hide_partner_access"></i>
									<div class="flex-column f-1-0 align-items-center gap-2">
										<div class="flex-row align-items-center gap-2">
											<i class="far fa-lock text-primary" style="font-size: 1.3rem;"></i>
											<b>Limited Access</b>
										</div>
										<span class="text-muted f-1-0" style="font-size: 0.9em;">Restrict partner access to usage statistics only</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="flex-row align-self-end gap-2" *ngIf="!allSectionsCompleted">
						<btn-c class="popup-action-btn p-2" variant="outlined" (action)="prevSection(sections.planFeatures)">Back</btn-c>
						<btn-c class="popup-action-btn p-2" (action)="nextSection(sections.planFeatures)">Next</btn-c>
					</div>
				</div>
			</div>
		</div>

        <!--Custom footer-->
        <div class="flex-row align-items-end justify-content-between gap-3 p-2">
            <!--Invoice notify-->
			<div class="flex-row f-1-0">
				<!--<div class="flex-row align-items-center bg-warning border border-warning gap-3 p-2 animated fadeIn"
					 style="&#45;&#45;bs-bg-opacity: .15;"
					 *ngIf="data.curSharedUser.invoiceNotify">
					<i class="far fa-exclamation-circle text-warning" style="font-size: 1rem;"></i>
					<span [innerHTML]="data.curSharedUser.invoiceNotify"></span>
				</div>-->
			</div>
            <div class="flex-row align-items-center gap-3 p-3">
				<btn-c class="popup-action-btn" variant="outlined"
					   (action)="data.closeCb()">
					Cancel
				</btn-c>
				<btn-c class="popup-action-btn"
					   [loading]="data.inProcess"
					   [isDisabled]="data.mode !== 'modify' && !allSectionsCompleted"
					   (action)="wizardConfirm()"
					   tooltip="All sections are complete.<br/>Click here to {{confirmLabel | lowercase}} the plan"
					   trigger="manual"
					   placement="top"
					   theme="light"
					   tooltipClass="triggered-info-tooltip"
					   #confirmTooltip="tooltip">
					{{confirmLabel}}
				</btn-c>
			</div>
        </div>

    </div>
</popup-c>
